module.exports = __webpack_public_path__ + "dist/media/logo--fi.4dad78fc.svg";